import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectionStrategy, HostListener, ElementRef } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  name = environment.name;
  production = environment.production;

  isCollapsed = true;
  isSticky = false;

  private themeQuery: MediaQueryList | null = null;
  private readonly onThemeChange = (event: MediaQueryListEvent): void => this.applyTheme(event.matches);

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.updateStickyState();
    // The theme follows the visitor's system preference.
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      this.themeQuery = window.matchMedia('(prefers-color-scheme: dark)');
      this.applyTheme(this.themeQuery.matches);
      this.themeQuery.addEventListener('change', this.onThemeChange);
    }
  }

  ngAfterViewInit(): void {
    this.publishHeaderHeight();
  }

  ngOnDestroy(): void {
    this.themeQuery?.removeEventListener('change', this.onThemeChange);
  }

  private applyTheme(isDark: boolean): void {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';
  }

  /* Publish the real header height so sections (like the hero) can fill
     100vh - header height exactly, without hard-coded offsets. */
  private publishHeaderHeight(): void {
    const height = this.elementRef.nativeElement.offsetHeight;
    if (height) {
      document.documentElement.style.setProperty('--vf-header-height', height + 'px');
    }
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.updateStickyState();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.publishHeaderHeight();
  }

  private updateStickyState(): void {
    this.isSticky = typeof window !== 'undefined' && window.scrollY > 48;
  }

  resetHamburguerIcon() {
    this.isCollapsed = !this.isCollapsed;
  }

  collapseNavbar() {
    this.isCollapsed = true;
  }

}
